import { pollUnlessNotFound } from '../../../Utils/queryOptions';
import { useQuery } from 'react-query';
import { adminUser } from '../../../API/TT_ELD/Users/admin';
import { TableParams } from '../../../Utils/TableTypes';

export const useAdmin = (
  adminName: string | undefined,
  adminEmail: string | undefined,
  status: boolean | null | undefined,
  tableParams: TableParams,
) => {
  return useQuery(
    ['admins', adminName, adminEmail, status, tableParams],
    () => adminUser.read(adminName, adminEmail, status, tableParams),
    { refetchOnWindowFocus: false },
  );
};

export const useAdminFindOne = (id: number | string | undefined) => {
  return useQuery([`adminFindOne/${id || 'all'}`, id], () => adminUser.adminFindOne(id), {
    refetchOnWindowFocus: false,
  });
};

export const useUnreadCount = (enabled: boolean) => {
  return useQuery('unreadCount', () => adminUser.unreadCount(), {
    refetchOnWindowFocus: false,
    enabled,
    refetchInterval: (_data, query) => pollUnlessNotFound(query, 5 * 60 * 1000),
    refetchIntervalInBackground: false,
  });
};
